import { render, staticRenderFns } from "./Loding.vue?vue&type=template&id=d894ba84&scoped=true&"
import script from "./Loding.vue?vue&type=script&lang=js&"
export * from "./Loding.vue?vue&type=script&lang=js&"
import style0 from "./Loding.vue?vue&type=style&index=0&id=d894ba84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d894ba84",
  null
  
)

export default component.exports